import React, { Component } from 'react';

class Compass extends Component {
  calculateDegreeChange(currentDegree, nextDegree) {
    let transformedDegree;
    
    if(Math.abs(currentDegree - nextDegree) > 180) {
      transformedDegree = (currentDegree - nextDegree > 0) ? 360 + nextDegree : nextDegree - 360;
    } else {
      transformedDegree = nextDegree;
    }
    
    return {
      directionVal: nextDegree,
      direction: transformedDegree
    };
  }
  componentWillMount() {
    this.setState({ 
      direction: this.props.wind.value,
      speed: this.props.speed.value,
      gust: this.props.gust.value
    });
  }
  componentWillReceiveProps(nextProps) {
    let data = Object.assign({
      speed: nextProps.speed.value,
      gust: nextProps.gust.value
    }, this.calculateDegreeChange(this.state.direction, nextProps.wind.value));

    this.setState(data);
  }
  constructor() {
    super();
    
    this.state = {
      direction: 0,
      directionVal: 0,
      speed: 0,
      gust: 0
    };
    
    this.calculateDegreeChange = this.calculateDegreeChange.bind(this);
  }
  render() {
    const compassStyle = {
      transform: `rotate(${this.state.direction}deg)`
    };
    return (
      <div className="compass-container">
        <div style={compassStyle} className="compass"></div>
        <div className="ring-container outer-ring"></div>
        <div className="ring-container inner-ring"></div>
        <div className="compass-display wind-direction">
          <div className="speed-details">
            <span className="speed-value">{this.state.speed}</span>
            <span className="wind-slash">/</span>
            <span className="gust-value">{this.state.gust}</span>
          </div>
          <div className="wind-direction-value">{this.state.directionVal}</div>
        </div>
      </div>
    );
  }
}

export default Compass;


/** WEBPACK FOOTER **
 ** ./src/Compass/Compass.js
 **/